import { Card, Checkbox, Col, Row} from 'antd';
import RightBar from '../../../../../components/common/RightBar';
import Footer from '../../../../../components/common/Footer';
import FormAction from '../../../../../components/common/FormAction';

const GeneralSettingsRightBar = [];

const OwnerCommunicationSettings = () => {

    return (
        <div className="page-container">
            <div className="main-container">
                {/* {showAlert && (
                    <Alert
                        message="Owner Communication Settings saved"
                        type="success"
                        showIcon
                        closable
                        onClose={() => setShowAlert(false)}
                        style={{ position: '', top: 20 }}
                    />
                )} */}
                <Card style={{ margin: '20px 0px 0px 0px', boxShadow: '0 4px 4px rgba(0, 0, 0, 0.1)' }}
                    title="Owner Communication Settings"
                >
                    <Row >

                        <Col style={{ color: 'gray' }} >
                            Show Site Manager on Owner Statements
                        </Col>
                        <Col span={1} style={{ display: 'flex', justifyContent: 'center' }} >
                            <Checkbox />
                        </Col>

                    </Row>

                    <Row style={{ marginTop: '20px' }}>
                        <FormAction />
                    </Row>
                </Card>

                <Footer />
            </div>
            <div className="RightSidebar">
                <RightBar RightBarData={GeneralSettingsRightBar} />
            </div>
        </ div>
    );
};

export default OwnerCommunicationSettings;
